<style scoped>
  .approval-words{font-size: 14px;color: #464c5b;line-height: 80px;padding-left: 20px;font-weight: bold;}
  .catalog{font-size: 16px;color: #00a2e9;display: inline-block;line-height: 80px;cursor: pointer;margin-right:40px}
  .list-panel{background-color: white;padding:0 40px}
  .list-title{color: #464c5b;font-size: 16px;font-weight: bold;}
  .list-schedule{color: #657180;font-size: 14px;}
  .list-host-text{font-size: 14px;color: #626c70;display: inline-block;margin-right: 19px;vertical-align: text-top;}
  .list-host-avatar{width: 30px;height: 30px;border-radius: 15px;margin-right: 10px;}
  .list-pending{font-size: 14px;display: inline-block;vertical-align: text-top;margin-top: 4px;color: #00a2e9;}
  .list-panel >>> .ivu-switch-checked{background-color:#45db5e;border-color:#45db5e;}
  .notice-background{background: url("/img/sys/bg11.png");height: 140px;}
  .enable{width: 70px;height: 20px;border-radius: 10px;}
</style>

<template>
  <div>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
  <div style="background-color: #fff;">
    <Row style="height: 80px;border-bottom: 1px solid #d7dde4;">
      <Col span="20" class="approval-words">模板列表（点击列表可预览模板）</Col>
      <Col span="4" style="text-align: right">
        <!--<Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: top;"/>新建-->
        <Icon type="md-add" color="#00a2e9" size="22" style="vertical-align: sub;"/>
        <router-link :to="{name:'approvalCreate',query:{typeId:$route.query.typeId}}"><p class="catalog">新建审批</p></router-link>
      </Col>
    </Row>
    <!---->
    <div class="list-panel">
      <Row justify="center">
        <Col v-for="(item,index) in list" span="24" style="height: 134px;border-bottom: 1px solid #d7dde4;display: flex;align-items: center;">
          <Col span="20" style="line-height: 38px;">
            <div class="list-title">
              {{item.name||'未命名模板'}}
              <Button v-if="true" style="background-color: #00a2e8;color: #fff;padding: 0;line-height: 19px;"
                      class="enable">已启用
              </Button>
              <Button v-else disabled style="background-color: #b2b2b2;color: #fff;padding: 0;line-height: 19px;"
                      class="enable">未启用
              </Button>
            </div>
            <p class="list-schedule">创建人：{{item.creater}} 时间：{{item.createTime}}</p>
          </Col>
          <Col span="4" style="text-align: right">
            <p class="list-pending">
              <router-link :to="{name:'approvalCreate',query:{typeId:$route.query.typeId},params:{approval:item}}"><span style="cursor: pointer;">修改</span></router-link> | <span style="cursor: pointer;" @click="deleteModel(item.id)">删除</span>
            </p>
            <!--<i-switch v-model="switch1" style="vertical-align: bottom;margin-left: 24px;"/>-->
          </Col>
        </Col>
      </Row>
      <Row>
        <Col span="24" style="margin:40px 0 57px 0;">
          <Page
              :show-sizer="true"
              :show-total="true"
              @on-page-size-change="search.pageSize=$event;getList()"
              :total="search.total"
              :page-size="search.pageSize"
              :page-size-opts="[5,10,15]"
              show-elevator
              @on-change="search.page = $event;getList()"
          />
        </Col>
      </Row>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: "modelList",
    data() {
      return{
        list:[],
        switch1:false,
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
      }
    },
    mounted:function(){
      this.getList(this.$route.query.typeId)
    },
    methods: {
      deleteModel:function(id){
        var _this = this
        _this.send({
          confirm:true,
          headers:'L/DeleteApprovalMode',
          data:{
            ApprovalModeId:id,
          },
          success:function (res) {
            _this.getList(_this.$route.query.typeId)
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除分类成功！',
            })
          }
        })
      },
      getList:function (id) {
        var _this = this
        _this.list = []
        _this.send({
          headers:'L/ShowApprovalMode',
          data:{
            ApprovalTypeId:id,
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.list,i,{})
              _this.$set(_this.list[i],'id',res.List[index].ApprovalModeId)
              _this.$set(_this.list[i],'name',res.List[index].ApprovalModeTitle)
              _this.$set(_this.list[i],'data',res.List[index].ApprovalModeContent)
              _this.$set(_this.list[i],'creater',res.List[index].UserName)
              _this.$set(_this.list[i],'typeName',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.list[i],'createTime',res.List[index].ApprovalModeCreatedTime)
              _this.$set(_this.list[i],'editTime',res.List[index].ApprovalModeUpdateTime)
              if(Boolean(res.List[index].ApprovalAssessorId)){
                _this.$set(_this.list[i],'approverList',res.List[index].ApprovalAssessorId.split(','))
              }else{
                _this.$set(_this.list[i],'approverList','')
              }
              if(Boolean(res.List[index].ApprovalCopyId)){
                _this.$set(_this.list[i],'copyList',res.List[index].ApprovalCopyId.split(','))
              }else{
                _this.$set(_this.list[i],'copyList','')
              }
              i++
            }
            _this.search.total=res.Count
          }
        })
      },
    },
  }
</script>

